import { isMobile } from "@/utils/chartUtil.js";
import chartDescIconPng from "@/assets/images/icons/chart_desc_icon.png";
import chartDescIconSvg from "@/assets/images/icons/chart_desc_icon.svg";
// let selectContainer = document.createElement('div');
// selectContainer.className = 'select_container browser';

export const setCheckBox = (
  chart_wrapper,
  checkList,
  type,
  selectContainer
) => {
  selectContainer.innerHTML = ""; // 기존 내용을 초기화

  checkList.forEach((obj, index) => {
    // 새로운 div 요소를 생성합니다
    let div = document.createElement("div");
    div.classList.add("select_list");
    const labelText = `${obj.value}`;
    // div의 innerHTML에 필요한 HTML을 추가합니다
    div.innerHTML = `
            <label id="label" style='text-align:center;'>
                <input id="${obj.key}" class="hiddenCheckbox" type="checkbox" name='${obj.key}'/>
                <div id="showCheckbox"></div>
                <span class="">${labelText}</span>
            </label>
        `;
    if (obj.desc) {
      div.innerHTML += `
            <div class="select_list_desc">
                <img src="${chartDescIconPng}" class="web"></img>
                <img src="${chartDescIconSvg}" class="mb"></img>
                <div class="select_list_desc_text">
                    <p data-content="chart" >${obj.desc}</p>
                </div>
            </div>
            `;
    }
    // 완성된 div 요소를 selectContainer에 추가합니다
    selectContainer.appendChild(div);
    // chart_wrapper.querySelector(`#${obj.key}`).checked = obj.checked;
    // console.log(chart_wrapper.querySelector(`#${obj.key}`));
  });
};

export const setCheckBoxLayout = (
  chart_wrapper,
  chart,
  checkList,
  type,
  state,
  selectContainer
) => {
  let windowWidth = window.innerWidth;
  let windowHeight = window.innerHeight;

  // console.log('state.isFull',state.isFull);

  const safeAreaInsetBottom = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--safe-area-inset-bottom");
  const safeAreaInsetBottomPixels = parseFloat(safeAreaInsetBottom) || 0;

  const safeAreaInsetTop = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--safe-area-inset-top");
  const safeAreaInsetTopPixels = parseFloat(safeAreaInsetTop) || 0;
  const vh = windowHeight * 0.01;
  state.adjustedHeight =
    vh * 100 - safeAreaInsetBottomPixels - safeAreaInsetTopPixels + 2;
  // console.log('state.adjustedHeight',state.adjustedHeight);

  if (windowWidth <= 576 || isMobile()) {
    // console.log('모바일확인',isMobile());
    if (state.isFull == false) {
      chart_wrapper.style.height = "auto";
    }
    // else{
    //     chart_wrapper.style.height="650px"
    // }
    if (selectContainer.parentElement) {
      // selectContainer가 이미 부모 요소에 추가되어 있다면 제거
      selectContainer.parentElement.removeChild(selectContainer);
    }
    // selectContainerMb를 원하는 위치에 삽입
    selectContainer.className = `select_container mobile ${type}`;
    chart_wrapper.insertBefore(selectContainer, chart);
    // selectContainerMb.style.display = "grid";
  } else {
    chart_wrapper.style.height = "700px";
    // 데스크톱 화면 크기일 때
    if (selectContainer.parentElement) {
      // selectContainerMb가 이미 부모 요소에 추가되어 있다면 제거
      selectContainer.parentElement.removeChild(selectContainer);
    }
    // selectContainer를 원하는 위치에 삽입
    selectContainer.className = `select_container browser ${type}`;
    chart.appendChild(selectContainer);
  }
  checkList.forEach((obj, index) => {
    // console.log(chart_wrapper.querySelector(`#${obj.key}`));
    chart_wrapper.querySelector(`#${obj.key}`).checked = obj.checked;
  });
  // console.log('chart_wrapper',chart_wrapper,'selectContainer',selectContainer,'checkList',checkList);
};
